/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import React from "react";
import FunctionalityButton from "./FunctionalityButton";
import axios from "axios";
import { getToken } from "@/helpers/accessTokenHelper";
import { getSiteIdentifier } from "@/helpers/siteIdentifierHelper";
import { getDriveItemId } from "@/helpers/fallback-response-helper";

export default function RejectAllChanges({ setStatus, loading, setHovered }) {
  const reviseDocument = async (revise, driveItemId, comments) => {
    return await axios.patch(
      `https://addins.api.dexterity.legal/gateway/api/v1/documents/revise?driveItemId=${driveItemId}`,
      {
        acceptRevision: revise,
        removeComments: comments,
      },
      {
        headers: {
          Authorization: "Bearer " + (await getToken()),
          "Site-Identifier": getSiteIdentifier(),
          "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
        },
      }
    );
  };

  async function acceptAllRevisions(revision) {
    loading(true);
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const driveItemId = getDriveItemId(JSON.parse(sessionStorage.getItem("document")));
      await Word.run(async (context) => {
        reviseDocument(revision, driveItemId, false)
          .then(async (response) => {
            const currentDocBody = context.document.body;
            currentDocBody.insertFileFromBase64(response.data.data, Word.InsertLocation.replace);
            await context.sync();
          })
          .then(() => {
            setStatus(true);
            loading(false);
          });
      }).catch(function (error) {
        console.log("error:", error);
      });
    });
  }
  return (
    <div>
      <FunctionalityButton
        buttonText="Reject All Changes"
        color="#2b579a"
        bgColor="#F6EAE7"
        onClickFunction={() => acceptAllRevisions(false)}
        setHovered={setHovered}
      />
    </div>
  );
}
